import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";


const renderRow = (faq, onEdit, isReadOnly, index) => (
    <Draggable key={faq.Id} draggableId={faq.Id.toString()} index={index} >
    {(provided) => (
      <tr
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
        style={{
          ...provided.draggableProps.style,
          borderBottom: "1px solid #ddd"
        }}
      >
        <td>  
            <div className="faqdiv">
                {faq.Question}  
            </div>
        </td>

        <td >
            <div className="faqdiv">
                {faq.Answer}
            </div>
        </td>
        <td>
          <Glyphicon
            glyph="pencil"
            className={`edit-glyph${isReadOnly ? ".disabled" : ""}`}
            onClick={isReadOnly ? undefined : () => onEdit(faq)}
            title="Изменить"
          />
        </td>
      </tr>
    )}
  </Draggable>
);

export const Table = ({ faqs, fetching, onEdit, isReadOnly,updateFaqDrop}) => {

  const onDragEnd = result => {
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;
    const newOrder = destination.index + 1
    let f = faqs[source.index -1];
    f.Order =  newOrder;
    updateFaqDrop(f);
   
  };

  return (
    <div className="faqPanel">
      {fetching === fetchingState.FETCHING && (
        <Alert bsStyle="info">Загрузка...</Alert>
      )}
      {fetching === fetchingState.FAILED && (
        <Alert bsStyle="danger">Ошибка загрузки</Alert>
      )}
      {fetching === fetchingState.FETCHED && (
        
        <DragDropContext onDragEnd={onDragEnd}>
          <table className="table table-hover ">
            <thead>
              <tr>
                <td>Вопрос</td>
                <td>Ответ</td>
                <td></td>
              </tr>
            </thead>
  
            <Droppable droppableId="rows">
              {(provided) => (
                <tbody 
                {...provided.droppableProps} ref={provided.innerRef}>
                  {
                    faqs.map
                    (
                        (faq,index) => 
                        (
                            renderRow(faq, onEdit, isReadOnly, faq.Order,index)
                        )
                    )
                  }
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/settings/faq/Table.jsx